import React from 'react';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { Flex } from './base/layout-components';

const Wrapper = styled(Flex)`
  position: relative;
  padding: 0.5rem 1rem;
  background: ${getColor('whisper')};
  border: 1px solid ${getColor('botticelli')};
  border-radius: 0.4rem;
`;

const Arrow = styled.div`
  position: absolute;
  width: 1rem;
  height: 1rem;
  background: ${getColor('whisper')};
  border-top-left-radius: 3px;
  border-left: 1px solid ${getColor('botticelli')};
  border-top: 1px solid ${getColor('botticelli')};
  right: calc(50%);
  top: -1px;
  transform: translate(50%, -50%) rotate(45deg);
`;
const ArrowedBox = ({ text, ...rest }) => {
  return (
    <Wrapper justify='center' {...rest}>
      <Arrow />
      {text}
    </Wrapper>
  );
};

export default ArrowedBox;
